import axios from 'axios'
import { createContext, useState, useEffect, useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

const AuthContext = createContext()

export const AuthContextProvider = ({ children }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const [auth, setAuth] = useState({ error: '', isAuthenticated: false, isInitialized: true })
  const [csrf, setCsrf] = useState('')
  const [simulation, setSimulation] = useState(undefined)

  const getCSRF = useCallback(async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_ROOT_API}/csrf/`, { withCredentials: true })
      let csrfToken = res.headers.get('X-CSRFToken')
      setCsrf(csrfToken)
    } catch (err) {
      console.log(err)
    }
  }, [])

  const getSession = useCallback(async () => {
    try {
      const { data } = await axios.get(`${process.env.REACT_APP_ROOT_API}/session/`, { withCredentials: true })
      if (data.isAuthenticated) {
        setAuth((a) => {
          return { ...a, isAuthenticated: true, isInitialized: false }
        })
        getCSRF()
      } else {
        setAuth((a) => {
          return { ...a, isAuthenticated: false, isInitialized: false }
        })
        getCSRF()
      }
    } catch (err) {
      console.log(err)
    }
  }, [getCSRF])

  useEffect(() => {
    getSession()
  }, [getSession])

  const login = async (e) => {
    e.preventDefault()
    const fd = new FormData(e.target)
    try {
      await axios.post(
        `${process.env.REACT_APP_ROOT_API}/login/`,
        JSON.stringify({ username: fd.get('username'), password: fd.get('password') }),
        {
          headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': csrf,
          },
          withCredentials: true,
        }
      )
      setAuth({ ...auth, isAuthenticated: true, error: '', isInitialized: false })
      getCSRF()
      if (location.state?.from) navigate(location.state.from)
      else navigate('/')
    } catch (err) {
      const error = err
      setAuth({ ...auth, error: error.response.data.detail })
    }
  }

  const logout = async () => {
    try {
      await axios.post(`${process.env.REACT_APP_ROOT_API}/logout/`, null, {
        headers: {
          'X-CSRFToken': csrf,
        },
        withCredentials: true,
      })
      setAuth({ ...auth, isAuthenticated: false })
      await getCSRF()
    } catch (err) {
      console.log(err)
    }
  }

  return (
    <>
      <AuthContext.Provider
        value={{ auth, setAuth, login, logout, getCSRF, getSession, csrf, simulation, setSimulation }}
      >
        {children}
      </AuthContext.Provider>
    </>
  )
}

export default AuthContext
